var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { Button, FormField, Input, InputList, Modal } from '../../shared';
import { services } from '../../../shared';
import './upload-document.scss';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
export var UploadDocument = function (_a) {
    var handleClose = _a.handleClose, show = _a.show, customerId = _a.customerId, reloadDocumentGrid = _a.reloadDocumentGrid, uploadCaseStageDocument = _a.uploadCaseStageDocument, _b = _a.referenceFrom, referenceFrom = _b === void 0 ? 1 : _b, isEmailSend = _a.isEmailSend;
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, reset = _c.reset, errors = _c.errors;
    var _d = useState(), documentCategories = _d[0], setDocumentCategories = _d[1];
    var _e = useState(null), selectedCategory = _e[0], setSelectedCategory = _e[1];
    var _f = useState(null), fileToUpload = _f[0], setFileToUpload = _f[1];
    var _g = useState(null), description = _g[0], setDescription = _g[1];
    var _h = useState(false), isDocUploaded = _h[0], setIsDocUploaded = _h[1];
    var caseId = useParams().caseId;
    var validation = {
        fileDescription: {
            types: { required: true },
            message: "Please select a file description",
        },
        documentCategoryId: {
            types: { required: true },
            message: "Please select a document category",
        },
        customerDocument: {
            types: { required: true },
            message: "Please select a file to upload",
        },
    };
    var changeCategory = function (e) {
        setSelectedCategory({
            id: Number(e.currentTarget.id),
            value: e.currentTarget.value,
            code: e.currentTarget.value,
            selectable: true,
        });
    };
    var handleUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = customerId;
                    if (!(referenceFrom == 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.uploadDocument({
                            id: 0,
                            customerId: customerId,
                            typeId: Number(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.value),
                            documentBinaryString: fileToUpload,
                            description: (description !== null && description !== void 0 ? description : '').trim() !== '' ? description : selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.code,
                            applicationId: Number(caseId),
                            isEmailSend: isEmailSend,
                        })];
                case 1:
                    _a.sent();
                    reloadDocumentGrid(id);
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    if (referenceFrom == 2) {
                        uploadCaseStageDocument({
                            binaryDataString: fileToUpload,
                            description: (description !== null && description !== void 0 ? description : '').trim() !== '' ? description : selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.code,
                            isCompressed: false,
                            mimeType: 'pdf',
                            typeId: Number(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.value),
                        });
                        handleClose();
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var formatValue = function (value) {
        var formattedValues = value.split(' ').map(function (s) {
            var ss = s.toLowerCase().split('');
            ss[0] = ss[0].toUpperCase();
            return ss.join('');
        });
        return formattedValues.join(' ');
    };
    var getDocumentCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
        var individual, address, general, categories, totalOption;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, services.getList('CustomerIdPrivateIndividual')];
                case 1:
                    individual = (_b = (_a = (_g.sent()).data) === null || _a === void 0 ? void 0 : _a.map(function (c) { return ({
                        id: c.id,
                        code: c.code,
                        displayText: formatValue(c.value),
                        value: formatValue(c.value),
                        selectable: true,
                    }); })) !== null && _b !== void 0 ? _b : [];
                    return [4 /*yield*/, services.getList('AddressIdPrivateIndividual')];
                case 2:
                    address = (_d = (_c = (_g.sent()).data) === null || _c === void 0 ? void 0 : _c.map(function (c) { return ({
                        id: c.id,
                        code: c.code,
                        displayText: formatValue(c.value),
                        value: formatValue(c.value),
                        selectable: true,
                    }); })) !== null && _d !== void 0 ? _d : [];
                    return [4 /*yield*/, services.getList('DocumentType')];
                case 3:
                    general = (_f = (_e = (_g.sent()).data) === null || _e === void 0 ? void 0 : _e.map(function (c) { return ({
                        id: c.id,
                        code: c.code,
                        displayText: formatValue(c.value),
                        value: formatValue(c.value),
                        selectable: true,
                    }); })) !== null && _f !== void 0 ? _f : [];
                    categories = [];
                    totalOption = individual.length + address.length + general.length;
                    if (individual.length > 0) {
                        if (totalOption > 6) {
                            individual.splice(0, 0, { id: -999, code: 'Individual', value: ' -- Individual -- ', selectable: false });
                        }
                        categories = __spreadArray(__spreadArray([], categories, true), individual, true);
                    }
                    if (address.length > 0) {
                        if (totalOption > 6) {
                            address.splice(0, 0, { id: -998, code: 'Address', value: ' -- Address -- ', selectable: false });
                        }
                        categories = __spreadArray(__spreadArray([], categories, true), address, true);
                    }
                    if (general.length > 0) {
                        if (totalOption > 6) {
                            general.splice(0, 0, { id: -997, code: 'General', value: ' -- General -- ', selectable: false });
                        }
                        categories = __spreadArray(__spreadArray([], categories, true), general, true);
                    }
                    setDocumentCategories(categories);
                    return [2 /*return*/];
            }
        });
    }); };
    var fileReader;
    var handleFileRead = function () {
        setFileToUpload(fileReader.result.toString());
    };
    var handleChange = function (files) {
        setFileToUpload(null);
        if (files === null || files === void 0 ? void 0 : files.length) {
            var file = files[0];
            if (file.size <= 4194304 && ['application/pdf', 'image/jpeg', 'image/png'].indexOf(file.type) > -1) {
                fileReader = new FileReader();
                fileReader.onloadend = handleFileRead;
                fileReader.readAsDataURL(file);
            }
        }
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handleUpload();
            setIsDocUploaded(true);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        setDescription(null);
        setSelectedCategory(null);
        reset({ documentCategoryId: null, fileDescription: null, customerDocument: null });
        if (!documentCategories)
            getDocumentCategories();
        if (isDocUploaded)
            setIsDocUploaded(false);
    }, [show]);
    return (React.createElement(Modal, { show: show, handleClose: handleClose, extendClass: "doc-upload" },
        React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            React.createElement(FormField, { label: "File to upload", error: errors.customerDocument && validation.customerDocument.message },
                React.createElement("input", { type: "file", id: "customerDocument", name: "customerDocument", "aria-invalid": (fileToUpload === null || fileToUpload === void 0 ? void 0 : fileToUpload.length) === 0 ? 'true' : 'false', onChange: function (e) { return handleChange(e.target.files); }, accept: "image/png, image/jpeg, application/pdf" }),
                React.createElement("p", { role: "alert", className: !fileToUpload ? 'c-form-field__error' : 'c-form-field__hidden' }, "Please select a file of type jpg/png/pdf with a file size less than 4MB")),
            React.createElement(FormField, { label: "Category", error: errors.documentCategoryId && validation.documentCategoryId.message },
                React.createElement(InputList, { id: "documentCategoryId", options: documentCategories, legend: "Select a document category", forceSelection: true, required: true, error: !!errors.documentCategoryId, ref: register(validation.documentCategoryId.types), inputListChangeHandler: changeCategory })),
            React.createElement(FormField, { label: "File Description", error: errors.fileDescription && validation.fileDescription.message },
                React.createElement(Input, { id: "fileDescription", placeHolder: "File Description", onChange: function (event) { return setDescription(event.target.value); }, error: !!errors.fileDescription, ref: register(validation.fileDescription.types) })),
            React.createElement("p", { className: "u-mb-1" }),
            React.createElement(Button, { type: "button", variant: "secondary", size: "small", onClick: handleClose }, "Cancel"),
            React.createElement(Button, { type: "submit", childClasses: "upload-button", variant: "primary", size: "small", dataValue: customerId, disabled: selectedCategory == null ||
                    fileToUpload === null ||
                    description === null ||
                    description === '' ||
                    isDocUploaded === true }, "Upload"))));
};
